import {createAction} from 'redux-act'

export interface FetchTriggerActionPayload {
  callback?: () => void;
}

export interface ApiListResponse<T = any> {
  result?: string;
  data: T[];
  [key: string]: any;
}

export interface CustomTypeFormActionPayload {
  form: any;
  success?: (...args: any[]) => void;
  error?: (...args: any[]) => void;
  callback?: () => void;
}

export interface ContactByIdActionPayload {
  id: any;
  data?: any;
}

export interface ApplicationCreateActionPayload {
  id: any;
  data?: any;
}

export interface PortfolioSetActionPayload {
  user_id?: any;
  date?: any;
  [key: string]: any;
}

export const handleTitle = createAction<string>('HANDLE_TITLE')
export const handleLoader = createAction<boolean>('HANDLE_LOADER')
export const handleClient = createAction<any>('HANDLE_CLIENT')
export const handleCurrency = createAction<any>('HANDLE_CURRENCY')
export const getClients = createAction('GET_CLIENTS')
export const handleClients = createAction<ApiListResponse>('HANDLE_CLIENTS')
export const handleClearClient = createAction<any>('HANDLE_CLEAR_CLIENT')
export const handleCurrentClient = createAction<any>('HANDLE_CURRENT_CLIENT')
export const getCurrencies = createAction('GET_CURRENCIES')
export const handleCurrencies = createAction<any[]>('HANDLE_CURRENCIES')
export const getUserAccounts = createAction('GET_USER_ACCOUNTS')
export const handleUserAccounts = createAction<ApiListResponse>('HANDLE_USER_ACCOUNTS')
export const getCourses = createAction('GET_COURSES')
export const handleCourses = createAction<any[]>('HANDLE_COURSES')
export const handleSidebarToggle = createAction('HANDLE_SIDEBAR_TOGGLE')
export const handleSidebarOpen = createAction('HANDLE_SIDEBAR_OPEN')
export const getSpendTypes = createAction('GET_SPEND_TYPES')
export const handleSpendTypes = createAction<ApiListResponse>('HANDLE_SPEND_TYPES')
export const postCustomType = createAction<CustomTypeFormActionPayload>('POST_CUSTOM_TYPE')
export const putCustomType = createAction<CustomTypeFormActionPayload>('PUT_CUSTOM_TYPE')
export const postCustomGroupType = createAction<CustomTypeFormActionPayload>('POST_CUSTOM_GROUP_TYPE')
export const postCustomClassType = createAction<CustomTypeFormActionPayload>('POST_CUSTOM_CLASS_TYPE')
export const getIncomeTypes = createAction('GET_INCOME_TYPES')
export const handleIncomeTypes = createAction<ApiListResponse>('HANDLE_INCOME_TYPES')
export const getPropertyTypes = createAction('GET_PROPERTY_TYPES')
export const handlePropertyTypes = createAction<ApiListResponse>('HANDLE_PROPERTY_TYPES')
export const getInvestTypes = createAction('GET_INVEST_TYPES')
export const handleInvestTypes = createAction<ApiListResponse>('HANDLE_INVEST_TYPES')
export const getGroupTypes = createAction('GET_GROUP_TYPES')
export const handleGroupTypes = createAction<ApiListResponse>('HANDLE_GROUP_TYPES')
export const getClassTypes = createAction('GET_CLASS_TYPES')
export const handleClassTypes = createAction<ApiListResponse>('HANDLE_CLASS_TYPES')
export const getActiveTags = createAction('GET_ACTIVE_TAGS')
export const handleActiveTags = createAction<any>('HANDLE_ACTIVE_TAGS')
export const getActiveSubcategories = createAction('GET_ACTIVE_SUBCATEGORIES')
export const handleActiveSubcategories = createAction<any>('HANDLE_ACTIVE_SUBCATEGORIES')
export const toggleMenu = createAction('TOGGLE_MENU')
export const getContacts = createAction('GET_CONTACTS')
export const getContactById = createAction<any>('GET_CONTACT_BY_ID')
export const handleContacts = createAction<ApiListResponse>('HANDLE_CONTACTS')
export const handleContactById = createAction<ContactByIdActionPayload>('HANDLE_CONTACT_BY_ID')
export const setContacts = createAction<any>('SET_CONTACTS')
export const getApplications = createAction('GET_APPLICATIONS')
export const handleApplications = createAction<ApiListResponse>('HANDLE_APPLICATIONS')
export const handleApplicationCreate = createAction<ApplicationCreateActionPayload>('GET_APPLICATION')
export const setApplications = createAction<any>('SET_APPLICATIONS')
export const handleSetPortfolio = createAction<PortfolioSetActionPayload>('HANDLE_SET_USER_PORTFOLIO');
export const handleGetPortfolioById = createAction<any>('HANDLER_GET_PORTFOLIO_BY_ID');
export const handleStartCall = createAction<string>('HANDLE_START_CALL');
export const handleStopCall = createAction('HANDLE_STOP_CALL');
export const handleLogoutInterface = createAction('HANDLE_LOGOUT_INTERFACE');

export const handleGetApplicationById = createAction<number | string>('HANDLE_GET_APPLICATION_BY_ID');
export const handleSetApplicationById = createAction<any>('HANDLE_SET_APPLICATION_BY_ID');
export const updateClientInStore = createAction<any>('UPDATE_CLIENT_IN_STORE');
export const syncClientsFromAPI = createAction<any[]>('SYNC_CLIENTS_FROM_API');
export const updateApplicationInStore = createAction<any>('UPDATE_APPLICATION_IN_STORE');
export const syncApplicationsFromAPI = createAction<any[]>('SYNC_APPLICATIONS_FROM_API');
